import { faCopyright } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function HeaderDuaContent() {
  return (
    <div className="container mt-20 flex justify-center items-center mb-20">
      <div className="w-3/4">
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-1">
            <h5 className="text-2xl font-bold">Lorem ipsum dolor sit amet.</h5>
            <p className="text-base text-slate-400 text-justify md:text-left mt-3">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Maiores,
              maxime blanditiis! Ex eius incidunt ipsam odio nobis nostrum totam
              magnam, molestiae labore praesentium aut. Rerum aut temporibus
              fugit tempore tempora.
            </p>
          </div>

          <div className="col-span-1">
            <h5 className="text-2xl font-bold">Lorem ipsum dolor sit amet.</h5>
            <p className="text-base text-slate-400 text-justify md:text-left mt-3">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Maiores,
              maxime blanditiis! Ex eius incidunt ipsam odio nobis nostrum totam
              magnam, molestiae labore praesentium aut. Rerum aut temporibus
              fugit tempore tempora.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 mt-7">
          <div className="col-span-1">
            <h5 className="text-2xl font-bold">Lorem ipsum dolor sit amet.</h5>
            <p className="text-base text-slate-400 text-justify md:text-left mt-3">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Maiores,
              maxime blanditiis! Ex eius incidunt ipsam odio nobis nostrum totam
              magnam, molestiae labore praesentium aut. Rerum aut temporibus
              fugit tempore tempora.
            </p>
          </div>

          <div className="col-span-1">
            <h5 className="text-2xl font-bold">Lorem ipsum dolor sit amet.</h5>
            <p className="text-base text-slate-400 text-justify md:text-left mt-3">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Maiores,
              maxime blanditiis! Ex eius incidunt ipsam odio nobis nostrum totam
              magnam, molestiae labore praesentium aut. Rerum aut temporibus
              fugit tempore tempora.
            </p>
          </div>

          <div className="col-span-1">
            <h5 className="text-2xl font-bold">Lorem ipsum dolor sit amet.</h5>
            <p className="text-base text-slate-400 text-justify md:text-left mt-3">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Maiores,
              maxime blanditiis! Ex eius incidunt ipsam odio nobis nostrum totam
              magnam, molestiae labore praesentium aut. Rerum aut temporibus
              fugit tempore tempora.
            </p>
          </div>
        </div>

        <div className="mt-7">
          <h5 className="text-2xl font-bold">Lorem ipsum dolor sit amet.</h5>
          <p className="text-base text-slate-400 mt-3">
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Id
            deserunt nesciunt asperiores sit nam quam odio quod molestiae
            tempore beatae? Unde ad, nihil facere iure ex illum minima placeat
            cumque nobis quod enim ab praesentium pariatur voluptates suscipit
            officia harum qui iusto tempore. Cupiditate explicabo error
            exercitationem deleniti molestias, impedit ab tempore unde quis
            facilis, repellendus ipsum rem ullam quas!
          </p>

          <p className="text-base text-slate-400 mt-2">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel ex hic
            totam, obcaecati fugit blanditiis quidem quaerat sunt mollitia ipsa
            quibusdam sint corrupti, enim voluptatem nisi. Quis dolores dicta
            quidem voluptate quae eveniet, eligendi quia ea veritatis fuga
            consectetur sunt voluptatum saepe, eaque autem totam nisi neque
            corrupti laudantium placeat asperiores, nostrum voluptates? Culpa
            nihil, est repudiandae distinctio cum minima.
          </p>
        </div>

        <p className="text-center text-xs mt-5">
          <span>
            <FontAwesomeIcon icon={faCopyright} className="text-dark" />
          </span>{" "}
          COPYRIGHT 2022 ALL GREEN CARE BLITZ
        </p>
      </div>
    </div>
  );
}
